// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flex-buttons[data-v-2055fb28]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.content-box[data-v-2055fb28]{text-align:center;margin:60px 25px 25px 25px}.title[data-v-2055fb28]{font-size:25px;text-align:center;color:#4abca5}", ""]);
// Exports
module.exports = exports;
